<template>

    <div class="mlpr">

        <div class="mlpr__header" v-show="$mq !== 'sm'">
            <img src="/img/magic/logo.svg" class="mlpr__header__logo" @click="goLanding">
        </div>

        <div class="mlpr__body">
            <div class="mlpr__bloc">

                <div class="mlpr__bloc__top">


                    <img src="/img/magic/illustration-magic-link.svg" class="img__96 illustration-magic-link">

                    <markdown class="mlpr__bloc__title" :text="computedTitle"></markdown>

                    <p class="mlpr__bloc__text">{{$t('magic_check_email_no_mail')}}</p>

                    <button class="mlpr__bloc__link__top" @click="tryAgain" v-show="step === ENUMSTEP.DEFAULT">{{$t('magic_check_email_send_again')}}</button>
                    <p class="mlpr__bloc__sent" v-show="step === ENUMSTEP.SENT">{{$t('magic_check_email_sent')}}</p>
                    <p class="mlpr__bloc__wait" v-show="step === ENUMSTEP.WAIT">{{$tc('magic_link_retry', counter, {x: counter})}}</p>

                </div>

                <div class="mlpr__bloc__bottom">

                    <p class="mlpr__bloc__text">{{$t('magic_connect_issue')}}</p>
                    <button class="mlpr__bloc__link__bottom" @click="login">{{$t('magic_connect again')}}</button>

                </div>
            </div>
        </div>

        <page-loader ref="loader"></page-loader>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Api from '@/api'

import SessionStorage from '@/helpers/sessionStorage'

import Auth from '@/modules/auth'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import Markdown from '@/components/Markdown'
import PageLoader from '@/components/PageLoader'

import {routerPushHelper} from '../router'

export default {

    name: 'magic-link-pre',

    components: {Markdown, PageLoader},

    watch: {

        counter: function (value) {
            if (value === 0) {
                this.stopDecrement()
                this.goStep(this.ENUMSTEP.DEFAULT)
            }
        }
    },

    computed: {
        ...Vuex.mapGetters(['lang']),

        loginEmail() {
            return SessionStorage.getItem('email')
        },

        computedTitle() {
            return this.$tc('magic_check_email_title', 0, {email: this.loginEmail})
        }
    },

    data() {

        return {
            ENUMSTEP: {
                DEFAULT: 'default',
                SENT: 'sent',
                WAIT: 'wait',
                SUCCESS: 'success',
                ERROR: 'error',
                EXPIRED: 'expired'
            },
            step: '',
            counter: 0,
            intervalFunction: function () {
            }
        }

    },

    mounted() {

        this.sendEmail()
        this.goStep(this.ENUMSTEP.DEFAULT)

    },

    methods: {

        goStep(step) {

            this.step = step

            switch (step) {
                case this.ENUMSTEP.DEFAULT:
                    UserFlow.setPage(this, 'magic_request_email')
                    break
                case this.ENUMSTEP.SENT:
                    UserFlow.setPage(this, 'magic_check_email')
                    break
            }
        },

        tryAgain() {

            Tag.clickAmplitude(this, 're_send')
            this.sendEmail(true)
        },

        sendEmail(tryAgain) {

            if (tryAgain) {
                this.goStep(this.ENUMSTEP.SENT)
            }
            const email = SessionStorage.getItem('email')
            Auth.sendMagicLinkEmail(email, this.lang)
                .then(() => {

                    if (tryAgain) {
                        setTimeout(() => {
                            this.goStep(this.ENUMSTEP.WAIT)
                            this.startDecrement()
                        }, 3000)
                    }

                })
                .catch(() => {
                    //bad email in sessionStorage
                    this.$router.push({path: '/login'})
                })

        },

        startDecrement() {

            this.counter = 30

            this.decrement()
        },

        stopDecrement() {
            clearInterval(this.intervalFunction)
        },

        decrement() {

            this.intervalFunction = setInterval(() => {
                this.counter = this.counter - 1
            }, 1000)
        },

        login() {
            this.$refs.loader.start()
            Api.provider.get(this.loginEmail)
                .then(data => {
                    const path = UserFlow.getLoginPathPostMagicForm(data)
                    routerPushHelper(this.$router, path)
                })
                .catch(() => {
                    this.$router.push({path: '/'})
                })
        },

        goLanding() {
            this.$router.push({path: '/'})
        }

    },

    destroyed() {

        this.stopDecrement()
    }

}
</script>

<style lang="scss" scoped>

.mlpr {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__header {
        width: 100%;
        padding: 22px;
        display: flex;
        justify-content: center;

        &__logo {
            height: 20px;
            object-fit: contain;
            cursor: pointer;
        }
    }

    &__body {
        width: 100%;
        display: flex;
        flex-grow: 1;
        background-color: $mint;
        @media screen and (min-width: $above-mobile-length) {
            align-items: center;
            justify-content: center;
        }
    }

    &__bloc {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        flex-grow: 1;
        text-align: start;
        padding: 48px 24px 24px;
        background-color: $white;
        @media screen and (min-width: $above-mobile-length) {
            max-width: 400px;
            border-radius: 12px;
            text-align: center;
        }

        &__top:lang(ar-sa) {
            line-break: anywhere;
        }

        &__bottom {
            width: 100%;
            text-align: center;
        }

        &__title {
            margin-top: 20px;
            font-size: 24px;
            font-weight: 600;
            line-height: 1.17;
        }

        &__text {
            margin-top: 20px;
            font-size: 15px;
            line-height: 1.33;
        }

        &__sent {
            font-size: 15px;
            font-weight: 600;
            line-height: 1.33;
            color: $forest;
        }

        &__wait {
            font-size: 15px;
            font-weight: 600;
            line-height: 1.33;
            color: $neutralsMoon;
        }

        &__link {
            &__top {
                font-size: 15px;
                font-weight: 600;
                line-height: 1.33;
                color: $aquamarine;
                background-color: $white;
                cursor: pointer;
            }

            &__bottom {
                margin-top: 4px;
                font-size: 14px;
                font-weight: 600;
                line-height: 1.43;
                color: $aquamarine;
                background-color: $white;
                cursor: pointer;
            }
        }
    }
}

.illustration-magic-link:lang(ar-sa) {
    transform: scaleX(-1);
}

</style>
